import { useAnimation } from 'motion/react';
import type { ForwardedRef } from 'react';
import { useImperativeHandle } from 'react';

import type { AnimeatableIconRef } from './types';

interface UseAnimatedIconOptions {
  /** Delay multiplier between each animated element (default: 0.1s) */
  staggerDelay?: number;
  /** Duration of each element's animation (default: 0.3s) */
  duration?: number;
}

export function useAnimatedIcon(
  ref: ForwardedRef<AnimeatableIconRef>,
  options: UseAnimatedIconOptions = {}
) {
  const { staggerDelay = 0.07, duration = 0.12 } = options;
  const controls = useAnimation();

  useImperativeHandle(ref, () => ({
    startAnimation: async () => {
      await controls.start((i) => ({
        pathLength: 0,
        opacity: 0,
        transition: { delay: i * staggerDelay, duration },
      }));
      await controls.start((i) => ({
        pathLength: 1,
        opacity: 1,
        transition: { delay: i * staggerDelay, duration },
      }));
    },
    stopAnimation: () => controls.start('visible'),
  }));

  return controls;
}
